export default function ThemeCard({ theme, selected, onClick }) {
    return (
        <div
            className={`wg-theme-card ${selected ? "selected" : ""}`}
            onClick={onClick}
        >
            <div className="wg-theme-preview" />
            <h3 className="wg-theme-name">{theme.name}</h3>
            <p className="wg-theme-desc">{theme.description}</p>
            <div className="wg-theme-meta">{theme.key}</div>
        </div>
    );
}